import { gql } from '@apollo/client';

export const GET_ALL_BILLING_CREDITS = gql`
  query GetAllBillingCredits($page: Int!, $limit: Int!, $filters: BillingCreditsFilterInput) {
    getAllBillingCredits(page: $page, limit: $limit, filters: $filters) {
      items {
        id
        billingType
        billingCreditAmount
        currentMonth
        currentYear
        user {
          id
          fullName
        }
      }
      count
    }
  }
`;

export const CREATE_BILLING_CREDIT = gql`
  mutation CreateBillingCredit($input: CreateBillingCreditInput!) {
    createBillingCredit(input: $input) {
      message
      status
    }
  }
`;

export const UPDATE_BILLING_CREDIT = gql`
  mutation UpdateBillingCredit($input: UpdateBillingCreditInput!) {
    updateBillingCredit(input: $input) {
      message
      status
    }
  }
`;

export const DELETE_BILLING_CREDIT = gql`
  mutation DeleteBillingCredit($id: String!) {
    deleteBillingCredit(id: $id) {
      message
      status
    }
  }
`;
